import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ApiMembersKaizenIdeasMutateType,
  PreviewWithFileType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  id: string;
  body: {
    title: string;
    content: RawDraftContentState;
    clientCompanyName: string;
    priorityRatingId: number;
    attachFiles: PreviewWithFileType[];
  };
};

const request = ({ id, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ kaizenIdea: body });
  return new ApiClient()
    .put<ApiMembersKaizenIdeasMutateType>(
      `/api/members/kaizen_ideas/${id}`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersKaizenIdeasUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersKaizenIdeasMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
